<section class="info-container">
    <!-- Sección Contacto -->
    <section id="contacto">
      <h2 class="animate__animated animate__fadeIn">Contacto</h2>
      <h3 class="subtitulo">Contrataciones</h3>
      <div class="contact-container">
        <!-- Email -->
        <div class="contact-item">
          <i class="fas fa-envelope"></i>
          <span>Matías Quiroga</span>
          <a href="mailto:tropilleros@gmail.com" class="contact-button email">
            <i class="fas fa-paper-plane"></i> Enviar Email
          </a>
        </div>
  
        <!-- Teléfono / WhatsApp -->
        <div class="contact-item">
          <i class="fab fa-whatsapp"></i>
          <span>+54 9 11-6437-7993</span>
          <a href="https://wa.me/5491164377993" target="_blank" class="contact-button whatsapp">
            <i class="fab fa-whatsapp"></i> WhatsApp
          </a>
        </div>
      </div>
    </section>
  
    <!-- Sección de Riders -->
    <section id="riders">
      <h2 class="animate__animated animate__fadeIn">Descargar Riders</h2>
      <div class="riders-container">
        <a href="assets/documentos/RAIDER SHOW ACUSTICO.pdf" download class="rider-button">
          <i class="fas fa-file-pdf"></i> Rider Acústico
        </a>
        <a href="assets/documentos/RIDER TECNICO SHOW BASICO.pdf" download class="rider-button">
          <i class="fas fa-file-pdf"></i> Rider Completo
        </a>
      </div>
    </section>
  </section>
  